import axios from "axios";

const APIURL = "https://sonapi.nantech.az";
export const login = async (data) => {
  try {
    const response = await axios.post(`${APIURL}/login`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data?.Message || "Login failed";
  }
};


export const registerUser = async (userData) => {
  const formData = new FormData();
  formData.append("name", userData.name);
  formData.append("password", userData.password);
  formData.append("gender", userData.gender);
  formData.append("fullname", userData.fullname);
  formData.append("email", userData.email);

  if (userData.file) {
    formData.append("file", userData.file);
  }

  try {
    const response = await axios.post(`${APIURL}/registr`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.Message || "Registration failed";
  }
};



export const forgetPassword = async (email) => {
  try {
    const response = await axios.post(`${APIURL}/forgetpassword`, { Email: email });
    return response.data;
  } catch (error) {
    throw error.response?.data?.Message || 'Xəta baş verdi';
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    const response = await axios.post(`${APIURL}/resetpassword`, { Token: token, NewPassword: newPassword });
    return response.data;
  } catch (error) {
    throw error.response?.data?.Message || 'Xəta baş verdi';
  }
};
